import React from 'react'
export default function Failed() {
    return (
        <div className="d-flex justify-content-center align-items-center flex-column " style={{height: '100vh'}}>
            <div className="d-flex">
            <i className="fa fa-times-circle text-danger" style={{fontSize:100}} aria-hidden="true" />
            </div>
            <br/>
            <h1 className="d-flex font-weight-400">Payment failed</h1>    
        </div>
    )
}
